export default [
  {
    path: '/main/arena/vei-off-temp',
    meta: {
      tag: 'list_vei_off_temp',
      name: 'Offset - Temperatura',
      breadcrumb: 'Offset - Temperatura'
    },
    component: () => import(/* webpackChunkName: "arena-vei-off-temp" */ '@/views/main/settings/arena/vei-off-temp/Index.vue'),
    children: [
      {
        path: '',
        name: 'listveiofftemp',
        meta: {
          tag: 'list_vei_off_temp',
          menu: 'settings',
          name: 'Offset - Temperatura'
        },
        component: () => import(/* webpackChunkName: "arena-vei-off-temp" */ '@/views/main/settings/arena/vei-off-temp/List.vue'),
      }
    ]
  }
]
